import { DataService } from 'api/DataService'

import { ObjectLabelValue } from 'utils/types/object-label-value'

export class CustomerService {
  public static async getCustomerGroupsAutocomplete(): Promise<
    Array<ObjectLabelValue>
  > {
    const response = await DataService({
      url: '/v1/customer_groups/autocomplete',
      type: 'GET'
    })

    if (response.status === 200) {
      return response.data.records.map(
        (record: { name: string; uuid: string }) =>
          ({
            label: record.name,
            value: record.uuid
          } as ObjectLabelValue)
      )
    }

    return []
  }
  public static async getCustomerDetail(uuid: string): Promise<any> {
    const response = await DataService({
      url: `/v1/customers/${uuid}`,
      type: 'GET'
    })

    if (response.status === 200) {
      return response?.data?.record
    }

    return {}
  }

  public static async getCustomerHistoric(
    uuid: string,
    page = 1,
    perPage = 25
  ): Promise<{
    historic: any[]
    pagination: {
      current_page: number
      per_page: number
      total_count: number
      total_pages: number
    }
  }> {
    const response = await DataService({
      url: `/v1/customers/${uuid}/historic?page=${page}&per=${perPage}`,
      type: 'GET'
    })

    if (response.status === 200) {
      return {
        historic: response.data.historic || [],
        pagination: response.data.pagination
      }
    }

    return {
      historic: [],
      pagination: {
        current_page: 1,
        per_page: perPage,
        total_count: 0,
        total_pages: 0
      }
    }
  }

  public static async updateCustomer(uuid: string, data: any): Promise<any> {
    const response = await DataService({
      url: `/v1/customers/${uuid}`,
      type: 'PATCH',
      data
    })

    if (response.status === 200) {
      return response?.data
    }

    return {}
  }
}
